import { isDev, isProd } from "./env";
import {
  JAVA_GCR_SERVER_API_URL_DEV,
  JAVA_GCR_SERVER_API_URL_PROD,
  JAVA_SERVER_API_URL_DEV,
  JAVA_SERVER_API_URL_PROD,
} from "./urls";

export { isProd, isDev };
export const useEmulator = (() => {
  return [
    typeof import.meta !== "undefined"
      ? import.meta.env?.VITE_USE_EMULATOR
      : undefined,
    typeof process !== "undefined" ? process.env?.VITE_USE_EMULATOR : undefined,
    typeof process !== "undefined"
      ? process.env?.FIREBASE_USE_EMULATOR
      : undefined,
    typeof process !== "undefined"
      ? process.env?.NEXT_PUBLIC_FIREBASE_USE_EMULATOR
      : undefined,
  ].some((value) => value === "true");
})();

const firebaseConfigProd = {
  apiKey: "AIzaSyC-rZFbuWxeqadm51a_UBuomCpRM29Rrxo",
  authDomain: "gloud-office-project.firebaseapp.com",
  projectId: "gloud-office-project",
  storageBucket: "gloud-office-project.appspot.com",
  messagingSenderId: "200439388024",
  appId: "1:200439388024:web:b1cbc216d2c2edc805da8d",
  measurementId: "G-VVKN03R49W",
};

// The team doesn't use a separate justscan-dev Firebase project — dev mode
// points at the same real project as prod.
const firebaseConfigDev = firebaseConfigProd;

export const firebaseConfig = isProd ? firebaseConfigProd : firebaseConfigDev;

const fcmVapidKeyProd =
  "BAyvNtjy98kR1Us-HRDmYDETsdtFVNfDnBkIFrsoKH99VUgJ87LYche6_fdO2fTwK9UQRBc4I53nhzb-na2AG10";

// Same project as prod (see firebaseConfigDev above), so the VAPID key pair
// is the same too.
export const fcmVapidKey = fcmVapidKeyProd;

export const javaServerApiUrl = isProd ? JAVA_SERVER_API_URL_PROD : "/";

// NOTE: in dev, the api url is proxyed to the dev api url
export const javaServerApiBrowserAxiosUrl = isProd
  ? JAVA_SERVER_API_URL_PROD
  : "/";

export const javaGcrServerApiBrowserAxiosUrl = isProd
  ? JAVA_GCR_SERVER_API_URL_PROD
  : JAVA_GCR_SERVER_API_URL_DEV;

// TODO : temporary solution for camera stream url
export const cameraStreamUrl = isProd
  ? "https://app-api.justscan.ai"
  : JAVA_SERVER_API_URL_DEV;
